import PropTypes from 'prop-types'


const measureHydroType = PropTypes.shape({
    hydroId: PropTypes.number, // Int,
    dataType: PropTypes.number, // Int,
    date: PropTypes.number, // DateTime,
    initialValue: PropTypes.number, // Option[Double],
    value: PropTypes.number, // Option[Double],
    measureMode: PropTypes.number, // Option[Int],
    status: PropTypes.number, // Option[Int],
    qualification: PropTypes.number, // Option[Int],
    nature: PropTypes.number, // Option[String],
    initialPoint: PropTypes.number, // Option[Int],
    validator: PropTypes.number, // Option[Int],
    manager: PropTypes.number, // Option[Int],
    producer: PropTypes.number, // Option[Int],
    jobExecutionId: PropTypes.number, // Option[Int],
    importDate: PropTypes.number, // Option[DateTime],
    updateDate: PropTypes.number, // Option[DateTime],
    updateLogin: PropTypes.string, // Option[String]
    codepoint: PropTypes.number,
})

const validationSelectFiltersType = PropTypes.shape({
    filterStatus: PropTypes.number,
    filterQualification: PropTypes.number,
    filterProducer: PropTypes.number,
    filterManager: PropTypes.number,
    filterValidator: PropTypes.number,
    filterSuperior: PropTypes.number,
    filterInferior: PropTypes.number,
})

export { measureHydroType, validationSelectFiltersType }